import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
    header: {
        fontSize: '13px',
        color: '#2ca8ff',
        marginBottom: '10px',
        borderBottom: '0.55px solid #f9f9f9',
        padding: '6px 2px',
    },
};
export function GroupPane(props) {
    const { text, style, children, renderHeader } = props;
    return (_jsxs("div", { style: style?.container, children: [!renderHeader ? (_jsx("p", { style: { ...styles.header, ...style?.header }, children: text })) : (renderHeader(text)), children] }));
}
